/**
 * Tenders Service
 * Abstraction layer for tender data API calls with pagination support
 */
import { api } from './api'

function mapTender(t) {
    let status = 'open'
    if (t.is_withdrawn) {
        status = 'closed'
    } else if (t.deadlineAt && new Date(t.deadlineAt) < new Date()) {
        status = 'expired'
    }

        const rawDeadline =
        t.deadline ||
        t.closing_date ||
        t.closingDate ||
        t.bidDeadline

    return {
        id: (t.external_ref_id || t.id || '').substring(0, 15),
        fullId: t.id,
        title: t.title || 'Untitled',
        publisher: t.buyer_name || t.buyer || 'Unknown Buyer',
        source: t.source_platform || t.source || 'Unknown',
        location: t.region || t.nation || 'Unknown Location',
        value: t.value_band || t.estimated_value || 'Not specified',
        published:t.published_date || t.publishedDate || t.startDate || null,
        deadline: rawDeadline || null,
        createdAt: t.created_at || null,
        updatedAt: t.updated_at || null,
        status,
    }
}

export const tendersService = {
    async getAll() {
        const res = await api.get('/admin/tenders?pageSize=1000')
        if (!res.success) throw new Error('Failed to fetch tenders')
        return res.data.map(mapTender)
    },

    async getPage(page = 1, pageSize = 50, source = '', status = '', search = '') {
        const params = new URLSearchParams({ page, pageSize })
        if (search) params.set('search', search)
        if (source) params.set('source', source)
        if (status) params.set('status', status)
        const res = await api.get(`/admin/tenders?${params}`)
        if (!res.success) throw new Error('Failed to fetch tenders')
        return {
            data: res.data.map(mapTender),
            pagination: res.pagination,
        }
    },

    async getSources() {
        const res = await api.get('/admin/tenders/sources')
        if (!res.success) throw new Error('Failed to fetch sources')
        return res.data
    },

    async getById(id) {
        const res = await api.get(`/admin/tenders/${id}`)
        if (!res.success) throw new Error('Failed to fetch tender')
        return res.data
    },

    async update(id, data) {
        const res = await api.put(`/admin/tenders/${id}`, data)
        if (!res.success) throw new Error('Failed to update tender')
        return res.data
    },

    async deleteTender(id) {
        const res = await api.delete(`/admin/tenders/${id}`)
        if (!res.success) throw new Error('Failed to delete tender')
        return res
    },

    async search(query) {
        const tenders = await this.getAll()
        const q = query.toLowerCase()
        return tenders.filter(
            (t) => t.title.toLowerCase().includes(q) || t.id.toLowerCase().includes(q)
        )
    },
}
